import { DOC_ASSOCIATION } from '@core/classes/Enums';

export default class DocumentAssociation {
	constructor(init) {
		this.type = DOC_ASSOCIATION.Customer;
		this.id = '';

		if (init) {
			this.type = init.type; // Use DOC_ASSOCIATION enum
			this.id = init.id; // Unique GUID that identifies the associated object
		}
	}
}
